<template>
    <div v-if="coach" class="coach-card" @click="toCoachProfile">
        <div class="coach-card-img">
            <div v-if="coach.avatar" class="coach-card-photo" :style="{ backgroundImage: `url('${coach.avatar}')` }" />
            <div v-else class="coach-card-initials">{{ initials }}</div>
        </div>
        <div class="coach-card-body">
            <div class="coach-card-header">
                <div class="coach-card-name">{{ coach.name || $t('common.not_available_short') }}</div>
                <rating-stars :value="stars" size="13" />
            </div>
            <div class="coach-card-sports">{{ sports || $t('common.not_available_short') }}</div>
            <div class="coach-card-tag">{{ coach.description || $t('common.not_available_short') }}</div>
        </div>
    </div>
</template>

<script>

import RatingStars from '@/components/common/RatingStars'
import { getInitials } from '@/utils/Common'

export default {
    name: "CoachCard",
    components: { RatingStars },
    props: {
        coach: {
            type: Object,
            default: null,
        }
    },
    computed: {
        initials(vm = this) {
            return getInitials(vm.coach?.name) || '-'
        },
        sports(vm = this) {
            return (vm.coach?.sport_areas || []).map(sport => vm.sportLabel(sport)).join(', ')
        },
        stars(vm = this) {
            return vm.coach?.rating?.stars || 0
        },
    },
    methods: {
        toCoachProfile() {
            const vm = this
            vm.pushRoute({ name: 'student.coach-profile', params: { uid: vm.coach.objectID } })
        }
    }
}
</script>

<style scoped>
.coach-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    height: 100%;
    transition: border-color 0.15s, transform 0.15s;
}

.coach-card:hover {
    border-color: var(--v-outline2-base);
    transform: translateY(-2px);
}

.coach-card-img {
    height: 80px;
    background: var(--v-surface2-base);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.coach-card-photo {
    width: 100%;
    height: 100%;
    background-position: 50% 50%;
    background-size: cover;
}

.coach-card-initials {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 800;
    color: #0C0E12;
    background: linear-gradient(135deg, #CCFF33 0%, #339999 100%);
}

.coach-card-body {
    padding: 12px;
}

.coach-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
}

.coach-card-header .coach-card-name {
    flex: 1 1 auto;
    min-width: 0;
}

.coach-card-name {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.coach-card-sports {
    font-size: 11px;
    color: var(--v-txtMuted-base);
    margin-top: 4px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.coach-card-tag {
    font-size: 11px;
    color: var(--v-txtSecondary-base);
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
